import Chaplin from 'everlane-chaplin'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { builder } from '@builder.io/react'
import addScript from 'base/lib/addScript'

import store from 'base/store'

import BannerRenderer, { BANNER_HEIGHT } from 'base/components/layout/banners/banner_renderer'
import { SWITCH_USER_BANNER_HEIGHT } from 'base/lib/banners'
import Footer from 'desktop/containers/layout/footer'
import GdprCookieMessageContainer from 'base/components/layout/gdpr_cookie_message'
import HeaderContainer from 'desktop/containers/layout/header_container'
import BuilderConfiguration from 'base/lib/builder_configuration'

// Layout represents the root layout for the entire application. Here we've
// designated the root region as being called content which can be found with
// the selector #content.
export default class Layout extends Chaplin.Layout {
  async getIsSticky() {
    const builderResult = await builder.get('banner').promise()
    const rotatingBanner = builderResult.data.blocks[0].children.find(
      child => child.component.name == 'Rotating Banner',
    ).component

    return rotatingBanner?.options?.isSticky
  }

  renderHeader() {
    const container = document.querySelector('.site-header-container')
    if (!container) return

    let bannerHeight = BANNER_HEIGHT
    const { isShadowingUser } = store.getState().appConfig

    if (isShadowingUser) {
      bannerHeight += SWITCH_USER_BANNER_HEIGHT
    }

    const header = (
      <Provider store={store}>
        <HeaderContainer bannerHeightOffset={bannerHeight} />
      </Provider>
    )

    this.getIsSticky().then(isSticky => {
      if (container) container.classList.toggle('site-header-container--sticky', !!isSticky)
    })

    ReactDOM.render(header, container)
  }

  renderBanner() {
    const container = document.querySelector('.builder-banner-container')
    if (!container) return

    const banner = (
      <Provider store={store}>
        <BuilderConfiguration />
        <BannerRenderer showCountrySelectModal={this.showCountrySelectModal} />
      </Provider>
    )

    this.getIsSticky().then(isSticky => {
      if (container) container.classList.toggle('builder-banner-container--sticky', !!isSticky)
    })

    ReactDOM.render(banner, container)
  }

  renderFooter() {
    const container = document.querySelector('.footer-container')
    if (!container) return
    const footer = (
      <Provider store={store}>
        <Footer />
      </Provider>
    )
    ReactDOM.render(footer, container)
  }

  renderGdprMessage() {
    const container = document.querySelector('.gdpr-container')
    if (!container) return
    const gdpr = (
      <Provider store={store}>
        <GdprCookieMessageContainer />
      </Provider>
    )
    ReactDOM.render(gdpr, container)
  }

  initializeTurnstile() {
    addScript('https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit', {}, true)
  }

  initializeGoogleAuth() {
    addScript('https://accounts.google.com/gsi/client', {}, true)
  }

  initialize(...args) {
    super.initialize(...args)
    this.renderBanner()
    this.renderHeader()
    this.renderFooter()
    this.renderGdprMessage()
    this.initializeTurnstile()
    this.initializeGoogleAuth()
  }
}

Object.assign(Layout.prototype, {
  autoRender: false,

  regions: {
    content: '#content',
    pre_content: '#pre_content',
    post_content: '#post_content',
  },
})
